import React, { createRef, useEffect, useState } from 'react'
function loadImg(url) {
  return new Promise(_resolve => {
    var img = new Image()
    img.src = url
    img.onload = function () {
      _resolve(img)
    }
  })
}
function random(min, max) {
  return Math.floor(Math.random() * (max - min) + min)
}
/**
 * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
 * images to fit into a certain area.
 *
 * @param {Number} srcWidth width of source image
 * @param {Number} srcHeight height of source image
 * @param {Number} maxWidth maximum available width
 * @param {Number} maxHeight maximum available height
 * @return {Object} { width, height }
 */
function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
  var ratio = Math.max(maxWidth / srcWidth, maxHeight / srcHeight)

  return { width: srcWidth * ratio, height: srcHeight * ratio }
}
const CanvasCardMaker = ({
  backgroundImage,
  frontalImage,
  mask = {
    /**
     * @image
     */
    image: '',
    props: {
      x: 60,
      y: 350,
      w: 100,
      h: 100,
    },
  },
  className = '',
  marcasAgua = [],
  handler = {},
}) => {
  const state = {
    foto: null,
    background: null,
    maskImage: null,
    marcasAguasList: [],
  }
  var context = null
  const canvasRef = createRef()

  const offset = {
    x: 0,
    y: 0,
    size: {
      width: 0,
      height: 0,
    },
    scale: 1,
  }

  handler.getContent = () => {
    if (!canvasRef || !canvasRef.current) {
      return null
    }
    drawCanvas(false)
    var content = canvasRef.current.toDataURL()
    drawCanvas()
    return content
  }

  const getPhotoPositionLeft = () => {
    return mask.props.x - offset.size.width / 2 + mask.props.w / 2 + offset.x
  }
  const getPhotoPositionTop = () => {
    return mask.props.y - offset.size.height / 2 + mask.props.h / 2 + offset.y
  }
  const recalcDimensions = (_canvas, imgWidth, imgHeight) => {
    if (!_canvas) {
      return
    }
    _canvas.width = imgWidth + 0
    _canvas.height = imgHeight + 0
  }
  const listenDragEvents = _canvas => {
    if (!canvasRef || !canvasRef.current || !state.background) {
      return
    }
    let down = false,
      touchStart = { x: 0, y: 0 }

    const getPosition = e => {
      let point = e.touches ? e.touches[0] : e
      return {
        x: point.pageX - _canvas.offsetLeft,
        y: point.pageY - _canvas.offsetTop,
      }
    }
    const startTouch = e => {
      down = true
      let position = getPosition(e)
      touchStart = { ...position }
    }

    const moveTouch = e => {
      //grab a box by the center
      if (down) {
        let position = getPosition(e)

        offset.x -= touchStart.x - position.x
        offset.y -= touchStart.y - position.y

        // limit..
        {
          // let x = getPhotoPositionLeft()
          // let y = getPhotoPositionTop()
          let limitLeft = offset.size.width * -0.2 //x + offset.size.width - (mask.props.x + mask.props.w)
          let limitRight = offset.size.width * 0.2 //x - mask.props.x
          let limitTop = offset.size.height * -0.2 // y + offset.size.height - (mask.props.y + mask.props.h)
          let limitBottom = offset.size.height * 0.2 //y - mask.props.y
          if (offset.x < limitLeft) {
            offset.x = limitLeft
          }
          if (offset.x > limitRight) {
            offset.x = limitRight
          }
          if (offset.y < limitTop) {
            offset.y = limitTop
          }
          if (offset.y > limitBottom) {
            offset.y = limitBottom
          }
        }
        drawCanvas()
        touchStart = { ...position }
      }
    }

    const endTouch = () => {
      //clear active so that dragging empty space wont move the last active box
      down = false
    }
    canvasRef.current.addEventListener('touchstart', startTouch)
    canvasRef.current.addEventListener('touchmove', moveTouch)
    canvasRef.current.addEventListener('touchend', endTouch)
    canvasRef.current.addEventListener('mousedown', startTouch)
    canvasRef.current.addEventListener('mousemove', moveTouch)
    canvasRef.current.addEventListener('mouseup', endTouch)
    canvasRef.current.addEventListener('mouseout', endTouch)
    canvasRef.current.addEventListener('contextmenu', e => e.preventDefault())
  }
  const drawCanvas = (withWaterMark = true) => {
    if (!context || !canvasRef || !canvasRef.current) {
      return
    }
    context.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height)
    if (state.foto) {
      offset.size = calculateAspectRatioFit(
        state.foto.width,
        state.foto.height,
        mask.props.w,
        mask.props.h
      )
      putPhoto()
      drawShape(true)
      drawBackground()
    } else {
      drawBackground()
      drawShape()
    }
    if (withWaterMark) {
      putMarcaAguas()
    }
  }
  const drawBackground = () => {
    if (!state.background) {
      return
    }
    context.save()
    context.globalCompositeOperation = 'destination-atop'
    context.drawImage(
      state.background,
      0,
      0,
      canvasRef.current.width,
      canvasRef.current.height
    )
    context.restore()
  }
  const putPhoto = () => {
    /// draw the shape we want to use for clipping
    if (!state.foto) {
      return
    }
    context.save()
    drawShape()

    /// change composite mode to use that shape
    context.globalCompositeOperation = 'source-in'

    let x = getPhotoPositionLeft(),
      y = getPhotoPositionTop()
    context.drawImage(state.foto, x, y, offset.size.width, offset.size.height)

    context.restore()
  }
  const drawShape = atop => {
    if (!state.maskImage) {
      return
    }
    if (atop) {
      context.save()
      //Secify the offset andz color of the shadow
      context.globalCompositeOperation = 'destination-atop'

      context.drawImage(
        state.maskImage,
        mask.props.x,
        mask.props.y,
        mask.props.w,
        mask.props.h
      )
      context.restore()
    } else {
      context.drawImage(
        state.maskImage,
        mask.props.x,
        mask.props.y,
        mask.props.w,
        mask.props.h
      )
    }
  }

  const putMarcaAguas = () => {
    if (
      !state.background ||
      !(state.marcasAguasList && state.marcasAguasList.length > 0)
    ) {
      return
    }

    context.save()
    const grid = {
      cols: 6,
      rows: 5,
    }
    let gridsize = {
      w: parseInt(canvasRef.current.width / grid.cols),
      h: parseInt(canvasRef.current.height / grid.rows),
    }
    context.globalAlpha = 0.3
    // iterate
    for (let x = 0; x < grid.cols; x++) {
      for (let y = 0; y < grid.rows; y++) {
        let img_marca_agua = state.marcasAguasList.shift()
        let s = 1 /// random(1, 5)
        let w = img_marca_agua.width * s
        let h = img_marca_agua.height * s

        context.drawImage(img_marca_agua, x * gridsize.w, y * gridsize.h, w, h)
        state.marcasAguasList.push(img_marca_agua)
      }
    }

    context.restore()
  }
  const initLoading = async () => {
    await loadImg(backgroundImage).then(src => {
      recalcDimensions(canvasRef.current, src.width, src.height)

      return (state.background = src)
    })

    if (frontalImage) {
      await loadImg(frontalImage).then(src => {
        return (state.foto = src)
      })
    }
    if (mask && mask.image) {
      await loadImg(mask.image).then(src => {
        return (state.maskImage = src)
      })
    }
    if (marcasAgua && marcasAgua.length > 0) {
      await Promise.all(marcasAgua.map(url => loadImg(url))).then(images => {
        return (state.marcasAguasList = images)
      })
    }

    drawCanvas()
    listenDragEvents(canvasRef.current)
  }
  useEffect(() => {
    console.log('render.canvas...')
    context = canvasRef.current.getContext('2d')
    initLoading()
  }, [canvasRef])
  return (
    <canvas className={'f-canvas-card-maker ' + className} ref={canvasRef} />
  )
}

export default CanvasCardMaker
